export const filters = () => {

  // Variables for toggle
  const $btnToggleListItem =	$('.js-toggle-list-item-button');
  const btnToggleListItem	=	'.js-toggle-list-item-button';
  // const $toggleListItem =	$('.js-toggle-list-item');
  // const toggleListItem	=	'.js-toggle-list-item';

  // Variables for filters
  const $filterByList =	$('.js-filter-by-list');
  const filterByList	=	'.js-filter-by-list';
  const $filterByItem	=	$('[data-filter-by]');
  const filterByItem =	'[data-filter-by]';
  const $toggleFiltersList =	$('.js-toggle-filters-list');
  const $filtersList =	$('.js-filters-list');
  const filtersList	=	'.js-filters-list';
  const $filterItem	=	$('[data-filter]');
  const filterItem =	'[data-filter]';
  const $items =	$('.js-items-to-filter');
  const items	=	'.js-items-to-filter';
  const $item	=	$('.js-item-to-filter');
  const item =	'.js-item-to-filter';
  const $filterItemCurrent = $('.js-filter__current');
  const filterItemCurrent = '.js-filter__current';

  const init = () => {

    if ($filterByList.length) {
  		var $activeFilterByItem;
  		if($filterByList.find('.is-active').length) {
  			$activeFilterByItem = $filterByList.find('.is-active');
        filterByView($activeFilterByItem.attr('data-filter-by'));
  			// filterItemsByCategory($activeFilterByItem.attr('data-filter'));
  		} else {
  			$activeFilterByItem = $filterByItem.eq(0);
  			$activeFilterByItem.addClass('is-active');
        filterByView($activeFilterByItem.attr('data-filter-by'));
  			// filterItemsByCategory($activeFilterByItem.attr('data-filter'));
  		}
  	}

  	if ($filtersList.length) {
  		var $activeItem;
  		if($filtersList.find('.is-active').length) {
  			$activeItem = $filtersList.find('.is-active');
  			filterItemsByCategory($activeItem.attr('data-filter'));
  		} else {
  			$activeItem = $filterItem.eq(0);
  			$activeItem.addClass('is-active');
  			filterItemsByCategory($activeItem.attr('data-filter'));
  		}
  	}

    bind();

  };

  const bind = () => {

      //Reset events related to lists
      $btnToggleListItem.on('click', function(evt) {
    		evt.preventDefault();
    		toggleListItem($(this));
    	});

      //Reset events related to filtering items.
      $toggleFiltersList.on('click', function(evt) {
        evt.preventDefault();
        toggleFiltersList();
      });

      $filterByItem.on('click', function(evt) {
        evt.preventDefault();
        //Add active class to listitem of filters
        $filterByList.find('.is-active').removeClass('is-active');
        $filterByList.find('[data-filter-by="' + $(this).attr('data-filter-by') + '"]').addClass('is-active');

        filterByView($(this).attr('data-filter-by'));
      });

      $filterItem.on('click', function(evt) {
        evt.preventDefault();
        //Add active class to listitem of filters
        $filtersList.find('.is-active').removeClass('is-active');
        $filtersList.find('[data-filter="' + $(this).attr('data-filter') + '"]').addClass('is-active');
        //Replace value of 'current'
        $filterItemCurrent.html($(this).html());
        $filterItemCurrent.attr('data-filter',$(this).attr('data-filter'));
        //Toggle the filters list visibility
        toggleFiltersList();
        //Filter items
        if($(this).parent().attr('data-filters-list') == '0') {
          filterItemsByCategory($(this).attr('data-filter'));
        } else if($(this).parent().attr('data-filters-list') ==  '1') {
          filterItemsByInitiative($(this).attr('data-filter'));
        }
      });

  };

  const toggleFiltersList = (listItem) => {

    $filtersList.toggleClass('is-toggled');

  };


  const toggleListItem = (listItem) => {

    listItem.closest('.js-toggle-list-item').toggleClass('is-toggled');

  };

  const filterByView = (filterValue) => {

    $('[data-view]').attr('data-view',filterValue);
  	$(item).removeClass('is-hidden');

  };

  const filterItemsByCategory = (filterValue) => {

    if(filterValue === '') {
  		$(item).removeClass('is-hidden');
  	} else {
  		$(item).addClass('is-hidden');
  		$(item+'[data-category*="'+filterValue+'"]').removeClass('is-hidden');
  	}

  };

  const filterItemsByInitiative = (filterValue) => {

    if(filterValue === '') {
  		$(item).removeClass('is-hidden');
  	} else {
  		$(item).addClass('is-hidden');
  		$(item+'[data-Initiative*="'+filterValue+'"]').removeClass('is-hidden');
  	}

  };

	if ($filterByList.length > 0) {
    init();
  }

};
